
const state = {
  userData: {},
  ptr: 0
}
const findVueComponent = (vue, id) => {
  console.log(vue)
  return vue.find(child => child.$el.id === id)
}
const mutations = {
  addUserData (state, payload) {
    state.userData[payload.id] = {}
    state.userData[payload.id].data = payload.data
    state.userData[payload.id].instance = findVueComponent(this.$app.$children, payload.id)
  },
  startAnimation (state) {
    Object.keys(state.userData).forEach(id => {
      console.log(state.userData[id].data[state.ptr % 30].value)
      const value = state.userData[id].data[state.ptr % 30].value
      state.userData[id].instance.startWithInterval(value)
      state.ptr += 1
    })
  },
  stopAnimation (state) {
    state.ptr = 0
    Object.keys(state.userData).forEach(id => {
      state.userData[id].instance.off()
    })
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
